module.exports = __webpack_public_path__ + "static/img/82-1.dc5b9d9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/82-1.jpg
// module id = TtX4
// module chunks = 0